import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import InsertDriver from "../../../components/driverComponent/insertDriver";
import { translate } from "react-i18next";
import ReadAxios from "../../../components/axiosComponent/read";
import DriverVehicles from "./driverVehicles";

class AddDrivers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "add_title",
      editData: {},
      driverVehicles : []
    };
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.title) {
      this.setState({
        title: this.props.location.state.title,
        editData: { ...this.props.location.state },
      });
      if(this.props.location?.state?.driverMasterId){
        this.getDriverPincodes(this.props.location?.state?.driverMasterId);
        this.getDriverVehicles(this.props.location?.state?.driverMasterId)
      }
    }
  }
  getDriverPincodes=(driver_id)=>{
    let pincodes = []
      ReadAxios({completeURL:`${process.env.REACT_APP_MASTER_API}/driverPincodeMapping/?driverId=${driver_id}`}).then((res)=>{
        if(res.data.status===200 && res.data.resultSet.length > 0){
          res.data.resultSet.map((item)=>{
            pincodes.push(item.pincodeMasterId)
          })
        }
        this.setState({
          editData : {...this.state.editData , pincodes}
        })
      })
  }

  getDriverVehicles=(driver_id)=>{
      ReadAxios({
        url:`vehicleDriver/driver/${driver_id}`}).then((res)=>{
        if(res?.data?.status===200 && res?.data?.resultSet?.length > 0){
          this.setState({driverVehicles : res?.data?.resultSet})
        }
      })
  }

  onFormSubmit = () => {
    this.props.history.push("/driver");
    this.props.history.go();
  };

  render() {
    return (
      <React.Fragment>
        <AddTitleBar Title={this.props.t(this.state.title)} LinkName="/driver" />
        <div className="m-2">
          <InsertDriver
            editData={this.state.editData}
            onFormSubmit={this.onFormSubmit}
          />

          {this.props.location?.state?.driverMasterId && 
          <DriverVehicles
          mappingData={this.state.driverVehicles}
          driverId={this.props.location.state.driverMasterId}
          />
          }
        </div>
      </React.Fragment>
    );
  }
}

export default translate("driver")(AddDrivers);
